<template>
  <div class="select-scope">
    <div class="content-row">
      <div class="row-left">
        <div v-if="!multiple && value[0]" class="var-container">
          <span v-tip class="var">{{ value[0].label }}</span>
          <div class="icon-close" @click="clearPeople">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <tree-select
          v-else
          :value="groupSelectValue"
          @input="handleSelectInProcess"
          :group-list="groupSelectOptions"
          :multiple="multiple"
        ></tree-select>
      </div>
      <el-tooltip effect="dark" content="打开通讯录" placement="bottom-end">
        <div class="btn-add buttonSelectTrigger" @click="$refs.selectUserScopeDialog.open()">
          <i class="el-icon-plus"></i>
        </div>
      </el-tooltip>
    </div>
    <select-user-scope-dialog
      ref="selectUserScopeDialog"
      :multiple="multiple"
      @select="handleSelect"
      scope="company"
      :additional-tabs="additionalTabs"
      v-bind="$attrs"
    ></select-user-scope-dialog>
  </div>
</template>

<script>
import TreeSelect from "@/components/UIComponents/TreeSelect"
import SelectUserScopeDialog from "@/components/SelectUserScopeDialog"
import { bfs } from "@/utils/algorithm"

export default {
  name: "SelectScope",
  components: {
    TreeSelect,
    SelectUserScopeDialog
  },
  props: {
    varGroup: {
      type: Array,
      default: () => []
    },
    value: Array,
    multiple: {
      type: Boolean,
      default: false
    },
    additionalTabs: {
      type: Array
      // default: () => [
      //   {
      //     label: "角色",
      //     value: "role",
      //     options: [{ id: "1", name: "测试" }]
      //   }
      // ]
    }
  },
  computed: {
    additionalLabelMap() {
      return (this.additionalTabs || [])
        .flatMap(t => t.options)
        .reduce((acc, cur) => Object.assign(acc, { [cur.id]: cur.name }), {})
    },
    commonSelected() {
      return (this.value || [])
        .filter(item => !this.varGroupMap[item.value])
        .map(item =>
          Object.assign({}, item, { label: item.label || this.additionalLabelMap[item.value] })
        )
    },
    commonSelectedMap() {
      return this._.keyBy(this.commonSelected, "value")
    },
    varGroupMap() {
      let map = {}
      bfs({
        arr: this.varGroup,
        cbk: group => Object.assign(map, this._.keyBy(group.options, "value"))
      })
      return map
    },
    groupSelectOptions() {
      return this.commonSelected.length == 0
        ? this.varGroup
        : this.varGroup.concat({ label: "通讯录", options: this.commonSelected })
    },
    groupSelectValue() {
      return this.multiple ? (this.value || []).map(t => t.value) : this.value?.[0]?.value || ""
    },
    typeMap() {
      let map = {
        user: "用户",
        department: "部门"
      }
      this.additionalTabs?.forEach(tab => (map[tab.value] = tab.label))
      return map
    }
  },
  methods: {
    handleSelectInProcess(items) {
      if (!this.multiple) {
        items = [items]
      }
      this.$emit(
        "input",
        items.map(t => this.varGroupMap[t] || this.commonSelectedMap[t])
      )
    },
    handleSelect(items) {
      let currentSelectedValues = this.value.map(v => v.value)
      items = items
        .filter(i => !currentSelectedValues.includes(i.value))
        .map(({ label, value, type }) => ({
          label: `${this.typeMap[type]}:${label}`,
          value,
          type
        }))
      this.$emit("input", this.multiple ? this.value.concat(items) : [items[0]])
    },
    clearPeople() {
      this.$emit("input", [])
    }
  }
}
</script>

<style lang="scss" scoped>
.select-scope {
  .content-row {
    display: flex;
    position: relative;
    .row-left {
      flex: 1 1;
      width: 0;
    }
    .tree-select {
      ::v-deep {
        .tree-select-tags {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
        .el-input {
          .el-input__inner {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            height: 40px;
            line-height: 40px;
          }
        }
      }
      ::v-deep .el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        height: 100%;
      }
    }
    .var-container {
      display: flex;
      align-items: center;
      position: relative;
      padding: 0 10px;
      background: #f8f8f8;
      border: 1px solid #ccc;
      height: 40px;
      line-height: 40px;
      border-radius: 4px 0 0 4px;
      box-sizing: border-box;
      &:hover {
        border-color: #2196f3;
      }
      .var {
        box-sizing: border-box;
        line-height: 28px;
        padding: 1px 10px;
        background-color: #01ca83;
        color: #fff;
        border-radius: 14px;
        border: 1px solid #9cd7f1;
        width: unset;
        max-width: 100%;
      }
      .icon-close {
        position: absolute;
        top: 0;
        right: 10px;
        width: 20px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        cursor: pointer;
        &:hover {
          color: #1e88e5;
        }
      }
    }
    .btn-add {
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-width: 1px 1px 1px 0;
      border-style: solid;
      box-sizing: border-box;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-color: #ddd;
      font-size: 20px;
      color: #9e9e9e;
      cursor: pointer;
      &:hover {
        color: #1e88e5;
      }
    }
  }
}
</style>
